export enum MergeMode {
  ALL = 'ALL',
  NEW_ONLY = 'NEW_ONLY',
  EXISTING_ONLY = 'EXISTING_ONLY',
}
